import getTargetType from './get-target-type';
import targetTypes from '../constants/target-types';
import { breakpointKeys } from '../constants/breakpoints';

const convertPlainBatchToBreakpointBasedBatch = (batch, breakpointKey) =>
  Object.fromEntries(
    Object.entries(batch).map(([elementId, targets]) => [
      elementId,
      Object.fromEntries(
        Object.entries(targets).map(([target, value]) => {
          const targetBreakpointKey =
            getTargetType(target) === targetTypes.ATTRIBUTE
              ? breakpointKeys.DEFAULT
              : breakpointKey;

          return [target, { [targetBreakpointKey]: value }];
        })
      ),
    ])
  );

export default convertPlainBatchToBreakpointBasedBatch;
